module.exports = __webpack_public_path__ + "static/media/logo.aed13c04.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.svg
// module id = 1080
// module chunks = 0